module.exports = __webpack_public_path__ + "static/img/12.90b7d88.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/12.png
// module id = vcNs
// module chunks = 0